import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Navigate } from "react-router-dom";
import { LoadingMessage } from "../components/UiStates";
import { useAuth } from "../auth/AuthContext";
import { APP_ROUTES } from "./routes";
export const PrivateGuard = ({ children }) => {
    const { isAuthReady, isAuthenticated } = useAuth();
    if (!isAuthReady)
        return _jsx(LoadingMessage, { text: "Loading\u2026" });
    if (!isAuthenticated)
        return _jsx(Navigate, { to: APP_ROUTES.login, replace: true });
    return _jsx(_Fragment, { children: children });
};
export const TradingGuard = ({ children }) => {
    const { isAuthReady, isAuthenticated, canAccessTrading } = useAuth();
    if (!isAuthReady)
        return _jsx(LoadingMessage, { text: "Loading\u2026" });
    if (!isAuthenticated)
        return _jsx(Navigate, { to: APP_ROUTES.login, replace: true });
    if (!canAccessTrading)
        return _jsx(Navigate, { to: APP_ROUTES.awaitingActivation, replace: true });
    return _jsx(_Fragment, { children: children });
};
export const AdminGuard = ({ children }) => {
    const { isAuthReady, isAuthenticated, isAdmin } = useAuth();
    if (!isAuthReady)
        return _jsx(LoadingMessage, { text: "Loading\u2026" });
    if (!isAuthenticated)
        return _jsx(Navigate, { to: APP_ROUTES.login, replace: true });
    if (!isAdmin)
        return _jsx(Navigate, { to: APP_ROUTES.dashboard, replace: true });
    return _jsx(_Fragment, { children: children });
};
